export { default } from './BrandsListRoutes'
